import { useQuery } from 'react-query';
import firebase from '../config/firebase.config';
import { getTeamMemberDetails } from '../services/teamMemberDetails';
import { queryKeys } from '../config/queryKeys';

const db = firebase.firestore();

/** Stale time for team member details (2 min) – avoid refetch on every mount */
const TEAM_MEMBER_DETAILS_STALE_MS = 2 * 60 * 1000;

/**
 * Team member details from Firestore, cached with React Query.
 *
 * @param {string | null | undefined} teamId - Team document ID; query is disabled when falsy
 * @returns {{ memberDetails, isLoading, isError, error, refetch, isFetching }}
 */
export function useTeamMemberDetails(teamId) {
  const {
    data: memberDetails = {},
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: queryKeys.teamMemberDetails.detail(teamId),
    queryFn: () => getTeamMemberDetails(db, teamId),
    enabled: Boolean(teamId),
    staleTime: TEAM_MEMBER_DETAILS_STALE_MS,
  });

  return {
    memberDetails,
    isLoading,
    isError,
    error: error || null,
    refetch,
    isFetching,
  };
}
